import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CountryRegion, isCountryRegion } from '../../default/country-region/types';

@Component({
  selector: 'gtd-affiliate-answers',
  templateUrl: './affiliate-answers.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AffiliateAnswersComponent implements OnInit {
  @Input() data: any[];
  @Input() type: 'drill-down' | 'default' = 'default';
  public mapData = [];

  public ngOnInit(): void {
    try {
      this.mapData = this.data.map((item) => {
        const question = JSON.parse(item.question?.question || item.question).question;
        const answers = this.parseAnswer(JSON.parse(item.answer));
        return { question, answers };
      });
    } catch {}
  }

  private parseAnswer(answer: unknown[]): string[] {
    if (isCountryRegion(answer[0])) {
      const countryRegionAnswer = answer[0] as CountryRegion;
      return [
        this.countryRegionAnswerToString(countryRegionAnswer.country_code || [], $localize`:@@common.country:Country` as 'Country'),
        this.countryRegionAnswerToString(countryRegionAnswer.region_code || [], $localize`:@@common.region:Region` as 'Region'),
      ];
    }
    return answer as string[];
  }

  private countryRegionAnswerToString(codes: string[], label: 'Country' | 'Region'): string {
    if (codes && codes.length > 0) {
      return `${label}: ${codes.join(', ')}`;
    } else {
      return '';
    }
  }
}
